
<ElFormItem
    v-if="!insetHide"
    :class="`condition-item condition-item--upload condition-item--${field} condition-item--${!!postfix}`"
    v-bind="formItemProps"
    :prop="formItemProps.prop || field"
>
    <ElUpload
        ref="uploadRef"
        v-bind="contentProps"
        :disabled="insetDisabled"
        class="condition-item__content"
        :file-list="checked"
        @update:file-list="customChange"
    >
        <template v-if="slotDefault || $slots.default" #default>
            <slot v-if="$slots.default" name="default"></slot>
            <component v-else :is="getNode(slotDefault, { backfill, query })"></component>
        </template>
        <template v-if="slotTrigger || $slots.trigger" #trigger>
            <slot v-if="$slots.trigger" name="trigger"></slot>
            <component v-else :is="getNode(slotTrigger, { backfill, query })"></component>
        </template>
        <template v-if="slotTip || $slots.tip" #tip>
            <slot v-if="$slots.tip" name="tip"></slot>
            <component v-else :is="getNode(slotTip, { backfill, query })"></component>
        </template>
        <template v-if="slotFile || $slots.file" #file>
            <slot v-if="$slots.file" name="file"></slot>
            <component v-else :is="getNode(slotFile, { backfill, query })"></component>
        </template>
    </ElUpload>
    <div v-if="postfix" class="condition-item__postfix">
        <template v-if="typeof postfix === 'string'">{{ postfix }}</template>
        <template v-else>
            <component :is="getNode(postfix, checked)"></component>
        </template>
    </div>
</ElFormItem>
